import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { dismissModal } from '../../../../service/modal-service'
import { getOpenAIPrompt } from '../../../../utils/help/aircon-service'
import Linkify from 'linkify-react'
import { FaWhatsapp } from 'react-icons/fa'
import { CloseButton } from '../../../commons/buttons/CloseButton'
import { modalVariants } from 'utils/frame-motion-variants'

export const AirconHelp = (props) => {

    const whatsAppNumber = props.whatsAppNumber

    const [ searchText, setSearchText ] = useState("")

    const [ help, setHelp ] = useState(getOpenAIPrompt("", "", whatsAppNumber))
    const [ isShowWhatsAppChat, setIsShowWhatsAppChat ] = useState(false)

    const handleSearch = (e) => {
        e.preventDefault()
        setSearchText(e.target.value) 
        if(e.target.value.length > 2){
            setHelp(getOpenAIPrompt(e.target.value, "", whatsAppNumber))
        }  else {
            setHelp(getOpenAIPrompt("", "", whatsAppNumber))
        }
    }

    useEffect(() => {
        if(help?.length > 0){
            // console.log(help)
        }
    }, [help])

    const options = {
        /* … */
        target: "_blank",
        className: "text-orange-600",
        rel: "follow referrer"
    };

  return (
    <>
    <div className="flex justify-center items-center right-0 top-0 fixed z-30 w-full h-full backdrop-blur-sm bg-black/10">
            <motion.div className="m-1 max-w-2xl w-full relative bg-white rounded-lg shadow"
                variants={modalVariants}
                initial="initial"
                animate="animate"
                exit="exit"
            >
                <div className="absolute top-0 bottom-0 m-auto h-[600px] bg-white rounded-lg shadow px-2 py-5 w-full">
                    <div className="flex justify-center items-center rounded-t border-b pb-2">
                        <h3 className="text-lg font-semibold text-orange-600 uppercase">
                            Help
                        </h3>
                        <CloseButton/>
                    </div> 
                    <div className='p-2 relative max-w-lg mx-auto my-1'>
                        <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                            <svg className="ml-1 w-6 h-6 text-gray-400 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                        </div>
                        <input
                            type="search"
                            className="pl-10 px-3 py-3 text-orange-600 w-full shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-sm focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                            placeholder="Start typing" name="searchText" value={searchText} onChange={(e) => handleSearch(e)}
                            style={{ transition: "all .15s ease" }} required
                        />
                    </div>                     
                    <div className='text-gray-500 text-sm h-[440px] overflow-y-scroll px-2'>
                        {help?.length > 0 ?
                        <>
                            {[...help].map((item, i) =>
                                <div key={i} className='leading-6'>
                                    {item.role === "user" &&
                                        <p className='pt-4 font-bold'>{item.content}</p>
                                    }
                                    {item.role === "assistant" &&
                                        <Linkify as="p" options={options}  className='pt-1'>{item.content}</Linkify>
                                    }
                                </div> 
                            )}
                        </>
                        :
                        <div className='text-center flex justify-center pt-5'>
                            <a href={`https://wa.me/${whatsAppNumber}`} target="_blank" rel="noreferrer" className='flex items-center text-white py-2 px-4 rounded-full bg-gradient-to-tl from-green-700 to-green-500 font-bold space-x-1'>
                                <div>Chat</div>
                                <FaWhatsapp className='text-2xl'/>
                            </a>
                        </div>
                        }
                        {/* <div className='text-center flex justify-center pt-5'>
                            {isShowWhatsAppChat ? 
                                <a href={`https://wa.me/${whatsAppNumber}`} target="_blank" rel="noreferrer" className='flex items-center text-white py-2 px-4 rounded-full bg-gradient-to-tl from-green-700 to-green-500 font-bold space-x-1'>
                                    <div>Chat</div>
                                    <FaWhatsapp className='text-2xl'/>
                                </a>
                            :   <button className='p-4 italic text-orange-600' type="button" onClick={() => setIsShowWhatsAppChat(true)}>
                                    I need help with something else
                                </button>   
                            }
                        </div> */}
                    </div>   
                </div>
            </motion.div>
        </div>
      </>
  )
}
